import Alpine from 'alpinejs';

Alpine.data('minicart', () => ({
  events: {
    ['x-on:keydown.escape.window.prevent']() {
      this.close();
    },
  },
  get cart() {
    return Alpine.store('cart');
  },
  get items() {
    return this.cart.items || [];
  },
  get total() {
    return this.cart.total_price || 0;
  },
  open() {
    this.$root.showModal();
  },
  close() {
    this.$root.close();
  },
  updateItemInCart(key, quantity) {
    this.items = this.items.map((item) => {
      item.working = item.key === key;
      return item;
    });

    Shopify.cart.update(key, quantity).catch((error) => {
      this.$dispatch(
        'toast:show', 
        {
          message: error.message,
          timeout: 2000,
          type: 'error',
        }, 
        true
      );
    });
  },
  removeItemFromCart(key) {
    let removedItem = this.items.find((item) => item.key === key);

    this.items = this.items.map((item) => {
      item.working = item.key === key;
      return item;
    });

    Shopify.cart.update(key, 0).then(() => {
      this.$dispatch(
        'toast:show',
        {
          message: `${removedItem.title} removed from cart.`,
          timeout: 2000,
          type: 'success',
        },
        true
      );

      if (this.items.length === 0) {
        this.close();
      }
    });
  },
}));